{
  "familyId": "SWW-VT-ONREGELMATIG",
  "questions": [
    {
      "id": "SWW-VT-ONREGELMATIG-001",
      "familyId": "SWW-VT-ONREGELMATIG",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_onregelmatig",
      "questionType": "multiple_choice",
      "question": "Wat is de verleden tijd van 'zijn' (hij ...)?",
      "context": null,
      "options": ["was", "is", "werd", "heeft"],
      "correctAnswer": 0,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "sww.tt-vt-verwarring", "label": "Tegenwoordige tijd verward met verleden tijd", "optionIndex": 1 },
          { "id": "sww.zijn-worden-verwarring", "label": "Verleden tijd van \"zijn\" en \"worden\" verward", "optionIndex": 2 },
          { "id": "sww.verb-confusion", "label": "Ander werkwoord (hebben) gekozen i.p.v. zijn", "optionIndex": 3 }
        ]
      },
      "conceptId": "vt_onregelmatig_zijn",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.75,
      "stimulusAids": [
        {
          "type": "verbTable",
          "data": { "verb": "zijn", "type": "onregelmatig", "forms": { "tt": ["ben", "bent", "is", "zijn"], "vt": ["was", "was", "was", "waren"] }, "label": "Onregelmatig werkwoord: zijn" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Onregelmatig werkwoord: zijn",
            "content": "'Zijn' is een onregelmatig werkwoord. De verleden tijd is 'was' (enkelvoud) of 'waren' (meervoud). Dit moet je uit je hoofd leren.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "'Was' is de verleden tijd van 'zijn'. 'Zijn' is een onregelmatig werkwoord: ik ben → ik was, hij is → hij was, wij zijn → wij waren.",
        "solutionSteps": [
          "'Zijn' is een onregelmatig werkwoord",
          "Tegenwoordige tijd: ik ben, hij is, wij zijn",
          "Verleden tijd: ik was, hij was, wij waren"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Hij was' is de verleden tijd van 'hij is'.",
          "1": "'Is' is de tegenwoordige tijd, niet de verleden tijd. De verleden tijd van 'zijn' is 'was'.",
          "2": "'Werd' is de verleden tijd van 'worden', niet van 'zijn'. Verwar deze twee niet! Worden → werd, zijn → was.",
          "3": "'Heeft' is de tegenwoordige tijd van 'hebben', een ander werkwoord. De verleden tijd van 'zijn' is 'was'."
        }
      }
    },
    {
      "id": "SWW-VT-ONREGELMATIG-002",
      "familyId": "SWW-VT-ONREGELMATIG",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_onregelmatig",
      "questionType": "multiple_choice",
      "question": "Wat is de juiste verleden tijd van 'denken'? (hij ...)",
      "context": null,
      "options": ["dacht", "denkde", "denkte", "docht"],
      "correctAnswer": 0,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.onregelmatig-als-regelmatig", "label": "Kofschip toegepast op onregelmatig werkwoord (denkde)", "optionIndex": 1 },
          { "id": "sww.kofschip-op-sterk-ww", "label": "Kofschip toegepast op onregelmatig werkwoord (denkte)", "optionIndex": 2 },
          { "id": "sww.vd-klinker-niet-veranderd", "label": "Verzonnen klinkerverandering (docht i.p.v. dacht)", "optionIndex": 3 }
        ]
      },
      "conceptId": "vt_onregelmatig_denken_fout",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.73,
      "stimulusAids": [
        {
          "type": "verbTable",
          "data": { "verb": "denken", "type": "onregelmatig", "forms": { "tt": ["denk", "denkt", "denkt", "denken"], "vt": ["dacht", "dacht", "dacht", "dachten"] }, "label": "Onregelmatig werkwoord: denken" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Onregelmatig werkwoord: denken",
            "content": "'Denken' is een onregelmatig werkwoord. De verleden tijd is 'dacht' (enkelvoud) of 'dachten' (meervoud). NIET 'denkde' of 'denkten' — dat zijn foute vormen.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "'Dacht' is de juiste vorm. 'Denken' is een onregelmatig werkwoord: de verleden tijd is 'dacht' (enkelvoud) of 'dachten' (meervoud). De klinker verandert: e → a, en er komt een -cht aan het eind.",
        "solutionSteps": [
          "'Denken' is onregelmatig (sterk werkwoord)",
          "Klinkerverandering: e → a",
          "Verleden tijd: ik dacht, hij dacht, wij dachten",
          "Dit moet je uit je hoofd leren — kofschip werkt hier niet"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Hij dacht' is de juiste verleden tijd. Denken is een onregelmatig werkwoord.",
          "1": "'Denkde' bestaat niet. Heel logisch dat je dit dacht — bij de kofschip-regel zou je 'denkde' krijgen. Maar 'denken' is onregelmatig: verleden tijd = dacht.",
          "2": "'Denkte' bestaat niet. Bij de kofschip-regel zou je 'denkte' kunnen verwachten, maar 'denken' is onregelmatig: verleden tijd = dacht.",
          "3": "'Docht' bestaat niet. Klinkerverandering bij 'denken' is e → a (niet o): dacht."
        }
      }
    },
    {
      "id": "SWW-VT-ONREGELMATIG-003",
      "familyId": "SWW-VT-ONREGELMATIG",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_onregelmatig",
      "questionType": "multiple_choice",
      "question": "Wat is de verleden tijd van 'mogen' (wij ...)?",
      "context": null,
      "options": ["mochten", "mogden", "moegen", "mochtte"],
      "correctAnswer": 0,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "sww.onregelmatig-als-regelmatig", "label": "Onregelmatig werkwoord regelmatig vervoegd", "optionIndex": 1 },
          { "id": "sww.vd-klinker-niet-veranderd", "label": "Klinkerverandering verkeerd toegepast (verzonnen vorm)", "optionIndex": 2 },
          { "id": "sww.dubbele-uitgang", "label": "Dubbele uitgang toegevoegd aan verleden tijd", "optionIndex": 3 }
        ]
      },
      "conceptId": "vt_onregelmatig_mogen",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Onregelmatig hulpwerkwoord: mogen",
            "content": "'Mogen' is een onregelmatig hulpwerkwoord. De verleden tijd is 'mocht' (enkelvoud) of 'mochten' (meervoud). Dit moet je uit je hoofd leren.",
            "icon": "lightbulb"
          }
        },
        {
          "type": "verbTable",
          "showWhen": "wrong",
          "data": { "verb": "mogen", "type": "onregelmatig", "forms": { "tt": ["mag", "mag", "mag", "mogen"], "vt": ["mocht", "mocht", "mocht", "mochten"] }, "label": "Onregelmatig hulpwerkwoord: mogen" }
        }
      ],
      "feedback": {
        "explanationText": "'Mochten' is de verleden tijd meervoud van 'mogen'. 'Mogen' is een onregelmatig hulpwerkwoord: ik mocht, wij mochten.",
        "solutionSteps": [
          "'Mogen' is een onregelmatig hulpwerkwoord",
          "Enkelvoud: ik mocht, hij mocht",
          "Meervoud: wij mochten, zij mochten"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Wij mochten' is de juiste verleden-tijdvorm.",
          "1": "'Mogden' bestaat niet. 'Mogen' is onregelmatig en volgt niet de kofschip-regel.",
          "2": "'Moegen' bestaat niet. De verleden tijd van 'mogen' is 'mocht/mochten'.",
          "3": "'Mochtte' bestaat niet. De vorm is 'mocht' (enkelvoud) of 'mochten' (meervoud), zonder extra -te."
        }
      }
    },
    {
      "id": "SWW-VT-ONREGELMATIG-004",
      "familyId": "SWW-VT-ONREGELMATIG",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_onregelmatig",
      "questionType": "multiple_choice",
      "question": "Welk werkwoord is NIET onregelmatig?",
      "context": null,
      "options": ["werken", "gaan", "komen", "zien"],
      "correctAnswer": 0,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.regelmatig-als-onregelmatig", "label": "Regelmatig werkwoord onterecht als onregelmatig aangemerkt", "optionIndex": 1 },
          { "id": "sww.regelmatig-als-onregelmatig", "label": "Regelmatig werkwoord onterecht als onregelmatig aangemerkt", "optionIndex": 2 },
          { "id": "sww.regelmatig-als-onregelmatig", "label": "Regelmatig werkwoord onterecht als onregelmatig aangemerkt", "optionIndex": 3 }
        ]
      },
      "conceptId": "vt_onregelmatig_herkennen",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Regelmatig vs. onregelmatig",
            "content": "Regelmatige werkwoorden volgen de kofschip-regel: werken → werkte. Onregelmatige werkwoorden veranderen van klank: gaan → ging, komen → kwam, zien → zag.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "'Werken' is een regelmatig (zwak) werkwoord: werken → werkte/werkten (kofschip: k). De andere werkwoorden zijn onregelmatig: gaan → ging, komen → kwam, zien → zag.",
        "solutionSteps": [
          "Werken → werkte (regelmatig, kofschip 'k')",
          "Gaan → ging (onregelmatig)",
          "Komen → kwam (onregelmatig)",
          "Zien → zag (onregelmatig)"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Werken' is regelmatig: werken → werkte/werkten.",
          "1": "'Gaan' is onregelmatig: gaan → ging/gingen (niet 'gaande' of 'goede').",
          "2": "'Komen' is onregelmatig: komen → kwam/kwamen (niet 'komde').",
          "3": "'Zien' is onregelmatig: zien → zag/zagen (niet 'ziede')."
        }
      }
    },
    {
      "id": "SWW-VT-ONREGELMATIG-005",
      "familyId": "SWW-VT-ONREGELMATIG",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_onregelmatig",
      "questionType": "fill_in",
      "question": "Vul de verleden tijd in: 'Gisteren ... (lopen) wij naar school.' Typ het juiste woord.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["liepen"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "sww.onregelmatig-als-regelmatig", "label": "Mogelijke fout: 'loopten' (kofschip op onregelmatig 'lopen')" },
          { "id": "sww.vt-enkelvoud-bij-meervoud", "label": "Mogelijke fout: 'liep' (enkelvoud) bij 'wij' (meervoud)" }
        ]
      },
      "conceptId": "vt_onregelmatig_lopen_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Onregelmatig werkwoord: lopen",
            "content": "'Lopen' is een onregelmatig werkwoord. De verleden tijd is 'liep' (enkelvoud) of 'liepen' (meervoud). NIET 'loopte' — dat is fout.",
            "icon": "lightbulb"
          }
        },
        {
          "type": "verbTable",
          "showWhen": "wrong",
          "data": { "verb": "lopen", "type": "onregelmatig", "forms": { "tt": ["loop", "loopt", "loopt", "lopen"], "vt": ["liep", "liep", "liep", "liepen"], "vd": ["gelopen"] }, "label": "Onregelmatig werkwoord: lopen (klinker: o → ie)" }
        }
      ],
      "feedback": {
        "explanationText": "'Liepen' is de verleden tijd meervoud van 'lopen'. Lopen is een onregelmatig werkwoord: ik liep, wij liepen (niet 'loopten').",
        "solutionSteps": [
          "'Lopen' is een onregelmatig werkwoord",
          "Enkelvoud: ik liep, hij liep",
          "Meervoud: wij liepen, zij liepen",
          "'Wij' = meervoud, dus: liepen"
        ]
      }
    },
    {
      "id": "SWW-VT-ONREGELMATIG-006",
      "familyId": "SWW-VT-ONREGELMATIG",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_onregelmatig",
      "questionType": "sentence_error_judge",
      "question": "In welke zin staat een fout? Klik op de zin met de verkeerde verleden-tijdvorm.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "sentences": [
          { "text": "Wij denkten gisteren aan de vakantie.", "hasError": true, "correction": "dachten", "explanation": "'Denken' is onregelmatig: denken → dacht → dachten. 'Denkten' bestaat niet." },
          { "text": "Hij was gisteren ziek.", "hasError": false },
          { "text": "Zij mochten niet meedoen.", "hasError": false },
          { "text": "Ik liep naar de winkel.", "hasError": false }
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.onregelmatig-als-regelmatig", "label": "Onregelmatig werkwoord 'denken' regelmatig vervoegd (denkten)" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Onregelmatige werkwoorden", "content": "Onregelmatige werkwoorden volgen NIET de kofschip-regel. 'Denken' → 'dacht/dachten' (niet 'denkten'). 'Zijn' → 'was/waren'. 'Mogen' → 'mocht/mochten'. 'Lopen' → 'liep/liepen'.", "icon": "lightbulb" } }
      ],
      "conceptId": "vt_onregelmatig_error",
      "variantIndex": 6,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "'Denkten' is fout. 'Denken' is een onregelmatig werkwoord: de verleden tijd is 'dacht' (enkelvoud) of 'dachten' (meervoud), niet 'denkten'. De andere zinnen zijn correct: was (zijn), mochten (mogen), liep (lopen).",
        "solutionSteps": [
          "Denkten → FOUT: denken is onregelmatig → dachten",
          "Was → goed (zijn → was)",
          "Mochten → goed (mogen → mochten)",
          "Liep → goed (lopen → liep)"
        ]
      }
    },
    {
      "id": "SWW-VT-ONREGELMATIG-007",
      "familyId": "SWW-VT-ONREGELMATIG",
      "module": "SpellingWW",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_onregelmatig",
      "questionType": "matching",
      "question": "Koppel elk onregelmatig werkwoord aan de juiste verleden-tijdvorm.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "zijn", "right": "was / waren" },
          { "left": "denken", "right": "dacht / dachten" },
          { "left": "lopen", "right": "liep / liepen" },
          { "left": "mogen", "right": "mocht / mochten" }
        ]
      },
      "pedagogy": { "dok": 1 },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Onregelmatige verleden tijd", "content": "Deze werkwoorden moet je uit je hoofd leren: zijn → was/waren, denken → dacht/dachten, lopen → liep/liepen, mogen → mocht/mochten.", "icon": "lightbulb" } }
      ],
      "conceptId": "vt_onregelmatig_matching",
      "variantIndex": 7,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Zijn → was/waren, denken → dacht/dachten, lopen → liep/liepen, mogen → mocht/mochten. Dit zijn onregelmatige werkwoorden die je uit je hoofd moet leren.",
        "solutionSteps": [
          "Zijn → was / waren",
          "Denken → dacht / dachten",
          "Lopen → liep / liepen",
          "Mogen → mocht / mochten"
        ]
      }
    }
  ]
}